/*
 * COPYRIGHT (c) 2023
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useContext, useEffect, useState } from 'react';
import AddUtilityBillComponent from './AddUtilityBillComponent';
import { UtilityBillFormComponent } from './UtilityBillFormComponent';
import { Button, Card, Checkbox, Loader, Modal, Popup } from '@scuf/common';
import UtilityManageBillTable from './UtilityManageBillTable';
import {
  convertToServerReadableFormat,
  formBillDataExisting,
  formBillDataNewEntry,
  formSchemaFromTable,
  formmanageBillTableData,
  initialformData,
  initialformDataForGas
} from './UtilityManageBillUtils';
import { IAny } from '../DashboardKPIWidgets/IEnergyManagementProps';
import './ViewBillDetailsFormComponent.scss';
import { ApiContext } from '../../context/ApiContext';
import moment from 'moment';
import AccountSuccess from '../../images/AccountSuccess.svg';
import errorIcon from '../../images/errorIcon.svg';
import { ToastNotification } from '../UtilityServiceModal/Notification';
import SharedTabsWidget from '../shared/SharedTabs/SharedTabs';
import ManageTariffParent from './TariffDetails/ManageTariffParent';
import {
  ApiMessages,
  UtilityServiceConstants,
  billWithNoDemand
} from './UtilityServiceConstants';
import descriptors from '../../locales/en-US/descriptors';
import { useTranslation } from '@scuf/localization';
import AddUtilityBillComponentMultipleUpload from './AddUtilityBillComponentMultipleUpload';
import AddUtilityBillComponentSingleUpload from './AddUtilityBillComponentSingleUpload';

interface BillDetail {
  date: string;
  cost: string;
}

interface IViewBillDetailsFormComponent {
  data: BillDetail[];
  isNewBill: boolean;
  billDetails: IAny;
  utilityCellData: IAny;
  onBillSave: IAny;
  setIsNewBill: IAny;
  cancelBill: IAny;
  newBillClick: IAny;
  setPDFResponse?: IAny;
  refreshTable?: boolean;
  isPDFExtracted: boolean;
  setIsPDFExtracted: (isPDFExtracted: boolean) => void;
  addNewBill: () => void;
  setRefreshTable: (a: boolean) => void;
  isMultipleUploaded: boolean;
  setIsMultipleUploaded: (a: boolean) => void;
  setIsWrongFile: (a: boolean) => void;
  isWrongFile: boolean;
}

export const ViewBillDetailsFormComponent = (
  props: IViewBillDetailsFormComponent
) => {
  const {
    data,
    isNewBill,
    utilityCellData,
    onBillSave,
    isPDFExtracted,
    setIsPDFExtracted,
    addNewBill,
    setRefreshTable,
    isMultipleUploaded,
    setIsMultipleUploaded,
    setIsWrongFile,
    isWrongFile
  } = props;
  const meterDetails = utilityCellData ? utilityCellData.meterDetails : [];
  const [pdfFile, setPDFFile] = useState<IAny>();

  const d = descriptors.energyManagement;
  const ub = descriptors.UtilityBuilder;
  const [t, lng] = useTranslation();

  const [billDetails, setBillDetails] = useState<IAny>({});
  const handleFileUpload = (base64Data: IAny) => {
    base64Data
      ? setBillDetails({
          ...billDetails,
          uploadedBill: base64Data,
          isBillUploaded: true
        })
      : setBillDetails({
          ...billDetails,
          uploadedBill: base64Data,
          isBillUploaded: false
        });
    setPDFFile(base64Data);
  };
  const [triggerNewBill, setTriggerNewBill] = useState<boolean>(false);
  const [displayTable, setIsDisplayTable] = useState<boolean>(false);
  const [form, setForm] = useState<IAny>({});
  const [totalCostError, setTotalCostError] = useState<boolean>(false);
  const [totalConsumptionError, setTotalConsumptionError] = useState<boolean>(
    false
  );
  const [totalDemandError, setTotalDemandError] = useState<boolean>(false);
  const [saveLoader, setSaveLoader] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');
  const [updateTable, setIsUpdateTable] = useState<boolean>(false);
  const [pdfError, setPdfError] = useState<boolean>(false);
  const [tariffDetails, setTariffDetails] = useState<IAny>([]);
  const [tariffValueMismatch, setTariffValueMismatch] = useState<IAny>(false);
  const [enableTOU, setEnableTOU] = useState<boolean>(false);
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [TOUTableData, setTOUTableData] = useState<IAny>([]);
  const [hasFieldChanged, setHasFieldChanged] = useState<boolean>(false);
  const [entryFromPDF, setEntryFromPDF] = useState<boolean>(false);
  const [entryTablePDF, setEntryTablePDF] = useState<boolean>(false);

  const apiContext = useContext(ApiContext);

  const { toggleManualWaterSewer } = apiContext;

  useEffect(() => {}, [tariffDetails]);

  const getTotalConsumptionTariff = () => {
    let totalconsumption: number = 0;
    let totalconsumptioncost: number = 0;
    tariffDetails.forEach((trf: IAny) => {
      if (!trf.tariffType.includes('Demand')) {
        totalconsumption = totalconsumption + Number(trf.consumption);
        totalconsumptioncost = totalconsumptioncost + Number(trf.cost);
      }
    });
    return [totalconsumption, totalconsumptioncost];
  };

  const getTotalCostTariff = () => {
    let totalcosttariff: number = 0;
    tariffDetails.forEach((trf: IAny) => {
      totalcosttariff = totalcosttariff + Number(trf.cost);
    });
    return totalcosttariff;
  };

  const getTotalDemamdTariff = () => {
    let totalDemand: number = 0;
    let totalDemandcost: number = 0;
    tariffDetails.forEach((trf: IAny) => {
      if (trf.tariffType.includes('Demand')) {
        totalDemand = totalDemand + Number(trf.consumption);
        totalDemandcost = totalDemandcost + Number(trf.cost);
      }
    });
    return [totalDemand, totalDemandcost];
  };

  useEffect(() => {
    if (props.billDetails && Object.keys(props.billDetails).length) {
      const tempBillDetails = JSON.parse(JSON.stringify(props.billDetails));
      if (billWithNoDemand.includes(utilityCellData.utilityType)) {
        delete tempBillDetails.billCategories.demand;
      }
      tempBillDetails.tCost = tempBillDetails.totalCost;
      tempBillDetails.tConsumption = tempBillDetails.totalConsumption;
      tempBillDetails.tDemand = tempBillDetails.totalDemand;

      // if(!tempBillDetails.consumptionUnit || tempBillDetails.consumptionUnit === null) {
      if (apiContext.ocrManageBill && isPDFExtracted) {
        tempBillDetails['logicalAccountId'] = utilityCellData.logicalAccountId;
        tempBillDetails['accountId'] = utilityCellData.accountId;
        tempBillDetails['consumptionUnit'] = utilityCellData.consumptionUnit;
        tempBillDetails['demandUnit'] = utilityCellData.demandUnit;
        tempBillDetails['currencyUnit'] = utilityCellData.currencyUnit;
      }

      // }

      setForm(tempBillDetails);
      setBillDetails(
        JSON.parse(
          JSON.stringify(
            formBillDataExisting(
              tempBillDetails,
              meterDetails,
              utilityCellData.utilityType
            )
          )
        )
      );
      setIsDisplayTable(true);
      apiContext.ocrManageBill && setIsUpdateTable(false);
    }
  }, [props.billDetails, isPDFExtracted]);

  useEffect(() => {
    console.log('final bill details ****', billDetails);
    // commented this below line for ocr Productization along with auto bill categories
    // apiContext.toggleAutomaticBillCategories && setIsUpdateTable(false);
  }, [billDetails]);

  useEffect(() => {
    setIsDisplayTable(false);
    return () => {
      const elem: IAny = document.getElementsByTagName('body')[0];
      if (elem.classList.contains('utility-builder-success')) {
        elem.classList.remove('utility-builder-success');
      }
    };
  }, []);

  useEffect(() => {
    if (isNewBill) {
      // setHasFieldChanged(true);
      const tempForm =
        utilityCellData.utilityType === UtilityServiceConstants.ELECTRICITY
          ? JSON.parse(JSON.stringify(initialformData))
          : JSON.parse(JSON.stringify(initialformDataForGas));
      if (utilityCellData) {
        tempForm['logicalAccountId'] = utilityCellData.logicalAccountId;
        // tempForm['accountId'] = utilityCellData.accountId;
        // tempForm['consumptionUnit'] = utilityCellData.consumptionUnit;
        // tempForm['demandUnit'] = utilityCellData.demandUnit;
        // tempForm['currencyUnit'] = utilityCellData.currencyUnit;
        // tempForm['startDate'] = '2023-08-01';
        // tempForm['endDate'] = '2023-09-01';
        setForm(tempForm);
      } else {
        !billWithNoDemand.includes(utilityCellData.utilityType)
          ? setForm(initialformData)
          : setForm(initialformDataForGas);
      }
      setTimeout(() => {
        setTriggerNewBill(true);
      }, 1000);
    }
  }, [isNewBill]);

  useEffect(() => {
    if (triggerNewBill) {
      setBillDetails(
        formBillDataNewEntry(
          meterDetails,
          form,
          utilityCellData.utilityType,
          utilityCellData
        )
      );
      setIsDisplayTable(true);
      setIsUpdateTable(true);
    }
    setTriggerNewBill(false);
  }, [triggerNewBill]);

  useEffect(() => {
    setForm(billDetails);
  }, [billDetails]);

  const getConsumptionAndDemandCost = () => {
    let cCost = 0;
    let dCost = 0;
    Object.keys(billDetails.billCategories).forEach((cnsp) => {
      if (cnsp === 'consumption') {
        billDetails.billCategories[cnsp].forEach((mtr: IAny) => {
          cCost = cCost + mtr.cost;
        });
      } else if (cnsp === 'demand') {
        billDetails.billCategories[cnsp].forEach((mtr: IAny) => {
          dCost = dCost + mtr.cost;
        });
      }
    });
    return [cCost, dCost];
  };

  const checkForTariffCost = () => {
    if (
      Number(getTotalConsumptionTariff()[1]) ===
        Number(getConsumptionAndDemandCost()[0]) &&
      Number(getTotalDemamdTariff()[1]) ===
        Number(getConsumptionAndDemandCost()[1])
    ) {
      console.log('tariff value mismatched');
      setTariffValueMismatch(false);
      return false;
    } else {
      setTariffValueMismatch(true);
      return true;
    }
  };

  const checkForDisableWithTariff = () => {
    let isnotEqual = false;
    console.log();
    if (
      billDetails &&
      !isNaN(Number(billDetails.tCost)) &&
      Number(billDetails.tCost) !== Number(billDetails.totalCost) &&
      Math.floor(Number(billDetails.tCost)) !==
        Math.floor(Number(billDetails.totalCost)) &&
      Math.ceil(Number(billDetails.tCost)) !==
        Math.ceil(Number(billDetails.totalCost))
    ) {
      setTotalCostError(true);
      isnotEqual = true;
    }
    if (
      (billDetails &&
        !isNaN(Number(billDetails.tConsumption)) &&
        Number(billDetails.tConsumption) !==
          Number(billDetails.totalConsumption) &&
        Math.floor(Number(billDetails.tConsumption)) !==
          Math.floor(Number(billDetails.totalConsumption)) &&
        Math.ceil(Number(billDetails.tConsumption)) !==
          Math.ceil(Number(billDetails.totalConsumption))) ||
      (Number(billDetails.tConsumption) !==
        Number(getTotalConsumptionTariff()[0]) &&
        Math.floor(Number(billDetails.tConsumption)) !==
          Math.floor(Number(getTotalConsumptionTariff()[0])) &&
        Math.ceil(Number(billDetails.tConsumption)) !==
          Math.ceil(Number(getTotalConsumptionTariff()[0]))) ||
      (Number(billDetails.totalConsumption) !==
        Number(getTotalConsumptionTariff()[0]) &&
        Math.floor(Number(billDetails.totalConsumption)) !==
          Math.floor(Number(getTotalConsumptionTariff()[0])) &&
        Math.ceil(Number(billDetails.totalConsumption)) !==
          Math.ceil(Number(getTotalConsumptionTariff()[0])))
    ) {
      setTotalConsumptionError(true);
      isnotEqual = true;
    }
    if (
      (billDetails &&
        !isNaN(Number(billDetails.tDemand)) &&
        Number(billDetails.tDemand) !== Number(billDetails.totalDemand) &&
        Math.floor(Number(billDetails.tDemand)) !==
          Math.floor(Number(billDetails.totalDemand)) &&
        Math.ceil(Number(billDetails.tDemand)) !==
          Math.ceil(Number(billDetails.totalDemand))) ||
      (Number(billDetails.tDemand) !== Number(getTotalDemamdTariff()[0]) &&
        Math.floor(Number(billDetails.tDemand)) !==
          Math.floor(Number(getTotalDemamdTariff()[0])) &&
        Math.ceil(Number(billDetails.tDemand)) !==
          Math.ceil(Number(getTotalDemamdTariff()[0]))) ||
      (Number(billDetails.totalDemand) !== Number(getTotalDemamdTariff()[0]) &&
        Math.floor(Number(billDetails.totalDemand)) !==
          Math.floor(Number(getTotalDemamdTariff()[0])) &&
        Math.ceil(Number(billDetails.totalDemand)) !==
          Math.ceil(Number(getTotalDemamdTariff()[0])))
    ) {
      setTotalDemandError(true);
      isnotEqual = true;
    }
    return isnotEqual;
  };

  const checkForDisable = () => {
    let isnotEqual = false;
    console.log();
    if (
      billDetails &&
      !isNaN(Number(billDetails.tCost)) &&
      Number(billDetails.tCost) !== Number(billDetails.totalCost) &&
      Math.floor(Number(billDetails.tCost)) !==
        Math.floor(Number(billDetails.totalCost)) &&
      Math.ceil(Number(billDetails.tCost)) !==
        Math.ceil(Number(billDetails.totalCost))
    ) {
      setTotalCostError(true);
      isnotEqual = true;
    }
    if (
      billDetails &&
      !isNaN(Number(billDetails.tConsumption)) &&
      Number(billDetails.tConsumption) !==
        Number(billDetails.totalConsumption) &&
      Math.floor(Number(billDetails.tConsumption)) !==
        Math.floor(Number(billDetails.totalConsumption)) &&
      Math.ceil(Number(billDetails.tConsumption)) !==
        Math.ceil(Number(billDetails.totalConsumption))
    ) {
      setTotalConsumptionError(true);
      isnotEqual = true;
    }
    if (
      billDetails &&
      !isNaN(Number(billDetails.tDemand)) &&
      Number(billDetails.tDemand) !== Number(billDetails.totalDemand) &&
      Math.floor(Number(billDetails.tDemand)) !==
        Math.floor(Number(billDetails.totalDemand)) &&
      Math.ceil(Number(billDetails.tDemand)) !==
        Math.ceil(Number(billDetails.totalDemand))
    ) {
      setTotalDemandError(true);
      isnotEqual = true;
    }
    return isnotEqual;
  };

  const isDisable = () => {
    let isBillCategoriesValid = true;
    const checkMeterHasCost = Object.keys(billDetails.billCategories).forEach(
      (bl: IAny) => {
        if (bl === 'consumption') {
          billDetails.billCategories[bl].forEach((b: IAny) => {
            if (
              (typeof b.consumption === 'number' &&
                typeof b.cost !== 'number') ||
              (typeof b.consumption !== 'number' && typeof b.cost === 'number')
              // ||
              // (!b.consumption && !b.cost)
            ) {
              isBillCategoriesValid = false;
            }
          });
        }
        if (bl === 'demand') {
          billDetails.billCategories[bl] &&
            billDetails.billCategories[bl].length &&
            billDetails.billCategories[bl].forEach((b: IAny) => {
              if (
                (typeof b.demand === 'number' && typeof b.cost !== 'number') ||
                (typeof b.demand !== 'number' && typeof b.cost === 'number')
              ) {
                isBillCategoriesValid = false;
              }
            });
        }
      }
    );
    // if (
    //   billDetails.startDate &&
    //   billDetails.endDate &&
    //   Number(billDetails.totalConsumption) !== 0 &&
    //   Number(billDetails.totalCost) !== 0 &&
    //   !isNaN(Number(billDetails.totalConsumption)) &&
    //   !isNaN(Number(billDetails.totalCost)) &&
    //   (utilityCellData.utilityType === 'Gas' ||
    //     !isNewBill ||
    //     billDetails.uploadedBill) &&
    //   isBillCategoriesValid &&
    //   (utilityCellData.utilityType === 'Gas' || !pdfError)
    // ) {
    //   return false;
    // }
    if (
      billDetails.startDate &&
      billDetails.endDate &&
      // Number(billDetails.totalConsumption) !== 0 &&
      Number(billDetails.totalCost) !== 0 &&
      !isNaN(Number(billDetails.totalConsumption)) &&
      !isNaN(Number(billDetails.totalCost)) &&
      isBillCategoriesValid &&
      !pdfError
    ) {
      return false;
    }
    return true;
  };

  const closeSuccessModal = (isCloseModal: boolean) => {
    if (!isCloseModal) {
      setMessage('');
      setIsDisplayTable(false);
    }
  };

  const getCardContent = (message: string) => {
    return (
      <Modal
        onClose={() => closeSuccessModal(false)}
        closeIcon={true}
        open={true}
      >
        <Modal.Content>
          {message === 'Bill saved successfully' ? (
            <img className="img-account-success" src={AccountSuccess} />
          ) : (
            <img className="img-account-success" src={errorIcon} />
          )}
          {message}
        </Modal.Content>
      </Modal>
    );
  };

  useEffect(() => {
    if (message) {
      // setTimeOut(()=> {
      //   setIsDisplayTable(false)
      // },5000)
      onBillSave();
    }
  }, [message]);

  const onTableDataChange = (toTableDate: IAny) => {
    setTotalCostError(false);
    setTotalConsumptionError(false);
    setTotalDemandError(false);

    if (toTableDate && toTableDate.length > 0) {
      setBillDetails({
        ...formBillDataExisting(
          formSchemaFromTable(toTableDate, form, utilityCellData.utilityType),
          meterDetails,
          utilityCellData.utilityType
        )
      });
    }
  };

  const cancelBill = () => {
    props.cancelBill();
  };

  // if (billDetails) {
  //   console.log("billdetails in dsaldaD", billDetails);
  //   // console.log("formmanageBillTableData(billDetails)", formmanageBillTableData(billDetails));
  // }

  const displayTabs = {
    displayTabs: [
      {
        className: 'emaas-carbondetail-view-details-total-emissions',
        title: 'Bill Categories',
        component: UtilityManageBillTable
      },
      {
        className: 'emaas-utility-view-details-scope-one',
        title: 'Tariff Details',
        component: ManageTariffParent
      }
    ]
    // bearerToken: bearerToken,
    // requestContext: requestContext,
    // ActiveIndex: apiContext?.ActiveIndex
  };

  const getMeterGuid = (billDetails: IAny) => {
    billDetails.billCategories.consumption.forEach((meter: IAny) => {
      utilityCellData.meterDetails.forEach((mtr: IAny) => {
        if (meter.meterId === mtr.meterNumber) {
          meter.meterId = mtr.meterId;
        }
      });
    });
  };
  const [enableEditBill, setEditBill] = useState<boolean>(false);

  useEffect(() => {
    if (isMultipleUploaded) {
      props.setIsNewBill(false);
      setIsDisplayTable(false);
      setIsPDFExtracted(false);
    }
  }, [isMultipleUploaded]);

  return isWrongFile ? (
    <div>Invalid File. Please refresh the page to continue.</div>
  ) : props.refreshTable ? (
    <Loader />
  ) : displayTable ? (
    <div className="container-utility-bill-div">
      <div className="utility-bill-upload-header">
        <span>
          {isNewBill
            ? t(ub.NEWBILL)
            : moment(billDetails.endDate)
                .locale(lng)
                .format('MMM YYYY')}
        </span>
      </div>
      {
        <div className="add-utility-bill">
          {apiContext.toggleMultipleUploadUtility && isNewBill ? (
            <AddUtilityBillComponentSingleUpload
              isNewBill={isNewBill}
              onFileUpload={handleFileUpload}
              utilityCellData={utilityCellData}
              billDetails={billDetails}
              setPdfError={setPdfError}
              setPDFResponse={props.setPDFResponse}
              setHasFieldChanged={(x: boolean) => {}}
              setEntryFromPDF={setEntryFromPDF}
              setEntryTablePDF={setEntryTablePDF}
              setIsUpdateTable={setIsUpdateTable}
              setTriggerNewBill={setTriggerNewBill}
              enableEditBill={enableEditBill}
              setIsPDFExtracted={setIsPDFExtracted}
              setEditBill={setEditBill}
              setIsNewBill={props.setIsNewBill}
              isPDFExtracted={isPDFExtracted}
              onBillSave={onBillSave}
              addNewBill={addNewBill}
              setBillDetails={setBillDetails}
              setIsDisplayTable={setIsDisplayTable}
              setIsMultipleUploaded={setIsMultipleUploaded}
            />
          ) : apiContext.ocrManageBill && (isNewBill || isPDFExtracted) ? (
            <AddUtilityBillComponentMultipleUpload
              isNewBill={isNewBill}
              onFileUpload={handleFileUpload}
              utilityCellData={utilityCellData}
              billDetails={billDetails}
              setPdfError={setPdfError}
              setPDFResponse={props.setPDFResponse}
              setHasFieldChanged={(x: boolean) => {}}
              setEntryFromPDF={setEntryFromPDF}
              setEntryTablePDF={setEntryTablePDF}
              setIsUpdateTable={setIsUpdateTable}
              setTriggerNewBill={setTriggerNewBill}
              enableEditBill={enableEditBill}
              setIsPDFExtracted={setIsPDFExtracted}
              setEditBill={setEditBill}
              setIsNewBill={props.setIsNewBill}
              isPDFExtracted={isPDFExtracted}
              onBillSave={onBillSave}
              addNewBill={addNewBill}
              setBillDetails={setBillDetails}
              setIsDisplayTable={setIsDisplayTable}
              setIsWrongFile={setIsWrongFile}
            />
          ) : (
            <AddUtilityBillComponent
              isNewBill={isNewBill}
              onFileUpload={handleFileUpload}
              utilityCellData={utilityCellData}
              billDetails={billDetails}
              setPdfError={setPdfError}
              setPDFResponse={props.setPDFResponse}
              setHasFieldChanged={(x: boolean) => {}}
              setEntryFromPDF={setEntryFromPDF}
              setEntryTablePDF={setEntryTablePDF}
              setIsUpdateTable={setIsUpdateTable}
              setTriggerNewBill={setTriggerNewBill}
              enableEditBill={enableEditBill}
              setIsPDFExtracted={setIsPDFExtracted}
              setEditBill={setEditBill}
              setIsNewBill={props.setIsNewBill}
              isPDFExtracted={isPDFExtracted}
              onBillSave={onBillSave}
              addNewBill={addNewBill}
              setBillDetails={setBillDetails}
              setIsDisplayTable={setIsDisplayTable}
            />
          )}
        </div>
      }
      {apiContext.ocrManageBill && isNewBill && (
        <div className="utility-manual-data-entry">
          <div className="horizontal-line"></div>
          <Checkbox
            label={t(ub.ENTERDATAMANUALLY)}
            checked={enableEditBill}
            onChange={(checked: boolean) => {
              if (!checked) {
                props.setIsNewBill(false);
                // setRefreshTable(true);
                setTimeout(() => {
                  addNewBill();
                }, 1000);
              }
              setEditBill(checked);
            }}
          />
        </div>
      )}
      {(!isNewBill ||
        enableEditBill ||
        isPDFExtracted ||
        !apiContext.ocrManageBill) && [
        <div className="utility-bill-form">
          <UtilityBillFormComponent
            setBillDetails={setBillDetails}
            billDetails={billDetails}
            utilityCellData={utilityCellData}
            isNewBill={isNewBill}
            totalCostError={totalCostError}
            setTotalCostError={setTotalCostError}
            totalConsumptionError={totalConsumptionError}
            setTotalConsumptionError={setTotalConsumptionError}
            totalDemandError={totalDemandError}
            setTotalDemandError={setTotalDemandError}
            isTariffPresent={apiContext.UtilityTariffDetailsToggle && enableTOU}
            setIsUpdateTable={setIsUpdateTable}
            toggleAutomaticBillCategories={
              apiContext.toggleAutomaticBillCategories
            }
            ocrManageBill={apiContext.ocrManageBill}
            setHasFieldChanged={(x: boolean) => {}}
            setEntryFromPDF={setEntryFromPDF}
            entryFromPDF={entryFromPDF}
            isPDFExtracted={isPDFExtracted}
          />
        </div>,
        <div className="utility-bil-table">
          {/* apiContext.UtilityTariffDetailsToggle */}
          {apiContext.UtilityTariffDetailsToggle &&
          utilityCellData.utilityType ===
            UtilityServiceConstants.ELECTRICITY ? (
            <SharedTabsWidget
              {...displayTabs}
              onTableDataChange={onTableDataChange}
              meterDetails={meterDetails}
              tableData={formmanageBillTableData(
                billDetails,
                utilityCellData.utilityType
              )}
              utilityCellData={utilityCellData}
              isNewBill={isNewBill}
              updateTable={updateTable}
              units={{
                demandUnit: isNewBill
                  ? utilityCellData.demandUnit
                  : billDetails.demandUnit,
                consumptionUnit: isNewBill
                  ? utilityCellData.consumptionUnit
                  : billDetails.consumptionUnit,
                currencyUnit: isNewBill
                  ? utilityCellData.currencyUnit
                  : billDetails.currencyUnit
              }}
              setTariffDetails={setTariffDetails}
              tariffValueMismatch={tariffValueMismatch}
              setTariffValueMismatch={setTariffValueMismatch}
              setEnableTOU={setEnableTOU}
              enableTOU={enableTOU}
              onTabChange={(activeIndex: number) => {
                setActiveIndex(activeIndex);
              }}
              setTotalConsumptionError={setTotalConsumptionError}
              setTotalDemandError={setTotalDemandError}
              TOUTableData={TOUTableData}
              setTOUTableData={setTOUTableData}
              isOcr={apiContext.ocrManageBill}
              toggleAutomaticBillCategories={
                apiContext.toggleAutomaticBillCategories
              }
            />
          ) : (
            [
              <span>{t(ub.BILLCATEGORIES)}</span>,
              <UtilityManageBillTable
                onTableDataChange={onTableDataChange}
                meterDetails={meterDetails}
                tableData={JSON.parse(
                  JSON.stringify(
                    formmanageBillTableData(
                      billDetails,
                      utilityCellData.utilityType
                    )
                  )
                )}
                utilityCellData={utilityCellData}
                isNewBill={isNewBill}
                updateTable={updateTable}
                units={{
                  demandUnit: isNewBill
                    ? utilityCellData.demandUnit
                    : billDetails.demandUnit,
                  consumptionUnit: isNewBill
                    ? utilityCellData.consumptionUnit
                    : billDetails.consumptionUnit,
                  currencyUnit: isNewBill
                    ? utilityCellData.currencyUnit
                    : billDetails.currencyUnit
                }}
                isOcr={apiContext.ocrManageBill}
                toggleAutomaticBillCategories={
                  apiContext.toggleAutomaticBillCategories
                }
                setHasFieldChanged={(x: boolean) => {}}
                entryTablePDF={entryTablePDF}
                setEntryTablePDF={setEntryTablePDF}
              />
            ]
          )}
        </div>
      ]}

      <div className="Manage-Bill-Save">
        {utilityCellData &&
          (utilityCellData.integrationType === 'Manual' ||
            (utilityCellData.integrationType === 'Automatic' && isNewBill)) && [
            message && getCardContent(message),
            saveLoader ? <Loader overlayColor={'transparent'} /> : <></>,
            <div className="cancel-save-builder-container">
              {(isNewBill || isPDFExtracted) && (
                <Button
                  type="secondary"
                  content={t(d.CANCEL)}
                  onClick={() => {
                    setIsWrongFile(false);
                    onBillSave();
                    props.setIsNewBill(false);
                    setIsDisplayTable(false);
                    setIsPDFExtracted(false);
                  }}
                />
              )}
              {(!apiContext.UtilityTariffDetailsToggle ||
                activeIndex === 1) && (
                <Button
                  disabled={isDisable()}
                  content={t(d.save)}
                  onClick={async () => {
                    setIsPDFExtracted(false);
                    setIsUpdateTable(false);
                    // const shouldSubmit = enableTOU && apiContext.UtilityTariffDetailsToggle ? !checkForDisable() && !checkForTariffCost() : !checkForDisable();
                    const shouldSubmit =
                      enableTOU && apiContext.UtilityTariffDetailsToggle
                        ? !checkForTariffCost() && !checkForDisableWithTariff()
                        : !checkForDisable();
                    if (shouldSubmit) {
                      const elem: IAny = document.getElementsByTagName(
                        'body'
                      )[0];
                      elem.classList.add('utility-builder-success');
                      props.setIsNewBill(false);

                      setSaveLoader(true);
                      console.log();
                      if (
                        // billWithNoDemand.includes(
                        //   utilityCellData.utilityType
                        // ) ||
                        !billDetails.uploadedBill ||
                        billDetails.uploadedBill === null
                      ) {
                        delete billDetails.uploadedBill;
                      }
                      if (apiContext.ocrManageBill) {
                        getMeterGuid(billDetails);
                      }

                      const isSaveSuccessfull = await apiContext.saveDillDetails(
                        convertToServerReadableFormat(
                          {
                            ...billDetails,
                            utilitiesType: utilityCellData.utilityType
                          },
                          isNewBill,
                          utilityCellData.utilityType,
                          pdfFile
                        )
                      );
                      setSaveLoader(false);
                      if (isSaveSuccessfull) {
                        // setIsDisplayTable(false);
                        if (isSaveSuccessfull === 200) {
                          setMessage(ApiMessages.BILLSAVED);
                        } else if (isSaveSuccessfull === 409) {
                          setMessage(ApiMessages.BILLPROCESSINGINPROGRESS);
                        } else if (isSaveSuccessfull === 400) {
                          setMessage(ApiMessages.BILLALREADYEXISTS);
                        } else {
                          setMessage(ApiMessages.ERRORPROCESSING);
                        }
                      } else {
                        setMessage(ApiMessages.ERRORPROCESSING);
                      }
                    }
                  }}
                />
              )}
            </div>
          ]}
      </div>
    </div>
  ) : (
    <></>
  );
};
